const featuredDevelopmentsCardGrid = {
  displayField: 'headline',
  name: 'Featured Developments Card Grid',
  description: '',
  fields: [
    {
      id: 'headline',
      name: 'Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'developmentIds',
      name: 'Development Ids',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Symbol', validations: [] }
    }
  ],
  sys: {
    id: 'featuredDevelopmentsCardGrid',
    version: 4,
    updatedAt: '2024-03-27T22:56:12.145Z'
  }
};
export default featuredDevelopmentsCardGrid;